/**
 * Home container.
 * @module components/theme/NotFound/NotFound
 * - Link removed from the middle text
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
/* import { Link } from 'react-router-dom'; */
import { Container } from 'semantic-ui-react';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';

/**
 * Not found function.
 * @function NotFound
 * @returns {string} Markup of the not found page.
 */
const NotFound = () => (
  <Container className="view-wrapper">
    <h1>
      <FormattedMessage
        id="This page does not seem to exist…"
        defaultMessage="This page does not seem to exist…"
      />
    </h1>
    <p className="description">
      <FormattedMessage
        id="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
        defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
      />
    </p>
    {/* <p>
      <FormattedMessage
        id="If you are certain you have the correct web address but are encountering an error."
        defaultMessage="If you are certain you have the correct web address but are encountering an error."
        values={{
          site_admin: (
            <Link to="/contact-form">
              <FormattedMessage
                id="Site Administration"
                defaultMessage="Site Administration"
              />
            </Link>
          ),
        }}
      />
    </p> */}
    <p>
      <FormattedMessage id="Thank you." defaultMessage="Grazie." />
    </p>
  </Container>
);

export default withServerErrorCode(404)(NotFound);
